"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./AccordionText.scss");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Toggle = require("../../containers/Toggle");

var _Toggle2 = _interopRequireDefault(_Toggle);

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var AccordionText =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(AccordionText, _PureComponent);

  function AccordionText() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AccordionText);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionText)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getIconType = function (on) {
      var onIcon = _this.props.icon === 'info' ? _freeSolidSvgIcons.faInfoCircle : _freeSolidSvgIcons.faChevronDown;
      return on ? _freeSolidSvgIcons.faChevronUp : onIcon;
    };

    _this.getIcon = function (on, className) {
      var _this$props = _this.props,
          icon = _this$props.icon,
          iconColor = _this$props.iconColor;
      return icon !== null ? _react2.default.createElement("div", {
        className: _this.getIconClasses(className)
      }, _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _this.getIconType(on),
        color: _this.props.icon === 'info' ? _styles.colors.secondaryColor : iconColor,
        alt: icon
      })) : null;
    };

    _this.getIconClasses = function (className) {
      var classes = ["".concat(className, "__button-container")];

      switch (_this.props.iconAlign) {
        case 'right':
          classes.push("".concat(className, "__button-container--alignRight"));
          break;

        case 'center':
          classes.push("".concat(className, "__button-container--alignCenter"));
          break;

        case 'left':
        default:
          break;
      }

      return classes.filter(Boolean).join(' ');
    };

    _this.getAccordionClasses = function (className) {
      var classes = ["".concat(className, "__header")];

      if (_this.props.marginTop) {
        classes.push("".concat(className, "__header--marginTop"));
      }

      if (_this.props.marginLeft) {
        classes.push("".concat(className, "__header--marginLeft"));
      }

      return classes.join(' ');
    };

    _this.getTextClasses = function (className) {
      var _this$props2 = _this.props,
          underline = _this$props2.underline,
          customLabelClass = _this$props2.customLabelClass;
      if (customLabelClass) return customLabelClass;
      var classes = ["".concat(className, "__text"), "".concat(className, "__labelText")];
      if (underline) classes.push("".concat(className, "--underline"));
      return classes.join(' ');
    };

    _this.getLabel = function (on) {
      var _this$props3 = _this.props,
          label = _this$props3.label,
          openLabel = _this$props3.openLabel;

      if (!on) {
        return label;
      }

      return openLabel !== undefined ? openLabel : label;
    };

    _this.getAccordionContent = function (on, className) {
      var _this$props4 = _this.props,
          children = _this$props4.children,
          inverted = _this$props4.inverted;

      if (on) {
        var content = _react2.default.createElement("div", {
          className: "".concat(className, "__container")
        }, children);

        return inverted ? {
          standard: null,
          inverted: content
        } : {
          standard: content,
          inverted: null
        };
      }

      return {
        standard: null,
        inverted: null
      };
    };

    _this.onTabbedKeystroke = function (event, toggleObject) {
      if (_this.expandKeyPressed(event.key)) {
        toggleObject();
      }
    };

    _this.handleToggle = function (isOpen) {
      if (_this.props.onToggle) _this.props.onToggle(isOpen);
    };

    return _this;
  }

  _createClass(AccordionText, [{
    key: "expandKeyPressed",
    value: function expandKeyPressed(key) {
      var acceptedKeys = ['Enter', 'ArrowDown'];
      return acceptedKeys.includes(key);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          labelColor = _this$props5.labelColor,
          secondLineLabel = _this$props5.secondLineLabel;
      var className = 'c-AccordionText';
      return _react2.default.createElement(_Toggle2.default, {
        on: !!this.props.isOpen,
        onToggle: this.handleToggle
      }, function (_ref) {
        var on = _ref.on,
            toggle = _ref.toggle;

        var accordionContent = _this2.getAccordionContent(on, className);

        return _react2.default.createElement("div", {
          className: "".concat(className, "__container")
        }, accordionContent.inverted, _react2.default.createElement("div", {
          tabIndex: 0,
          onKeyDown: function onKeyDown(event) {
            return _this2.onTabbedKeystroke(event, toggle);
          },
          onClick: toggle,
          className: _this2.getAccordionClasses(className)
        }, _react2.default.createElement("h3", {
          className: _this2.getTextClasses(className),
          style: {
            color: labelColor
          }
        }, _this2.getLabel(on), secondLineLabel ? _react2.default.createElement("div", {
          className: "".concat(className, "__secondLineLabel")
        }, secondLineLabel) : _react2.default.createElement(_react2.default.Fragment, null)), _this2.getIcon(on, className)), accordionContent.standard);
      });
    }
  }]);

  return AccordionText;
}(_react.PureComponent);

AccordionText.defaultProps = {
  icon: 'default',
  iconAlign: 'left',
  iconColor: 'inherit',
  label: '',
  labelColor: 'inherit',
  children: null,
  underline: false
};
exports.default = AccordionText;